import React from "react";
import ReactHtmlParser from "react-html-parser";
import StyledHeading from "./headerComponents";
import { Container } from "../Elements/Container";

const Heading = (props) => {
  return (
    <StyledHeading
      style={props.color && { background: props.color }}
      className={props.className}
    >
      <Container
        color={props.color}
        justifyConten="center"
        alignItem="center"
        flexDirection="column"
      >
        {ReactHtmlParser(props.content)}
      </Container>
    </StyledHeading>
  );
};

export default Heading;
